var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepeat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0007 6.74975H13.7957L14.7657 5.77975C15.0587 5.48675 15.0587 5.01275 14.7657 4.71975C14.4727 4.42675 13.9977 4.42675 13.7047 4.71975L11.4547 6.96975C11.1617 7.26175 11.1617 7.73575 11.4537 8.02875L13.6937 10.2787C13.8407 10.4267 14.0327 10.4998 14.2257 10.4998C14.4167 10.4998 14.6077 10.4267 14.7547 10.2807C15.0477 9.98875 15.0497 9.51475 14.7567 9.22075L13.7897 8.24975H15.0007C17.4817 8.24975 19.5007 10.2688 19.5007 12.7498C19.5007 15.2308 17.4817 17.2498 15.0007 17.2498H9.00073C6.51973 17.2498 4.50073 15.2308 4.50073 12.7498C4.50073 10.2688 6.51973 8.24975 9.00073 8.24975C9.41473 8.24975 9.75073 7.91375 9.75073 7.49975C9.75073 7.08575 9.41473 6.74975 9.00073 6.74975C5.69173 6.74975 3.00073 9.44075 3.00073 12.7498C3.00073 16.0588 5.69173 18.7498 9.00073 18.7498H15.0007C18.3097 18.7498 21.0007 16.0588 21.0007 12.7498C21.0007 9.44075 18.3097 6.74975 15.0007 6.74975",
    fill: "#0F67BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat);
export default __webpack_public_path__ + "static/media/Repeat.aa48bb340441d0be2b7cf58a4974ed85.svg";
export { ForwardRef as ReactComponent };